import { NgModule } from '@angular/core';

// modules (angular)
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

// modules (third-party)
import { CarouselModule } from 'ngx-owl-carousel-o';

// modules
import { SharedModule } from '../../shared/shared.module';

// blocks
import { BlockBannerComponent } from './block-banner/block-banner.component';

import { BlockProductsCarouselComponent } from './block-products-carousel/block-products-carousel.component';
import { BlockSlideshowComponent } from './block-slideshow/block-slideshow.component';

// components
import { BlockHeaderComponent } from './components/block-header/block-header.component';

@NgModule({
    declarations: [
        // blocks
        BlockBannerComponent,
        BlockProductsCarouselComponent,
        BlockSlideshowComponent,
        // components
        BlockHeaderComponent
    ],
    imports: [
        // modules (angular)
        CommonModule,
        RouterModule,
        // modules (third-party)
        CarouselModule,
        // modules
        SharedModule
    ],
    exports: [
        // blocks
        BlockBannerComponent,
        BlockProductsCarouselComponent,
        BlockSlideshowComponent
    ]
})
export class BlocksModule { }
